<ng-container *transloco="let t">
  <div class="flex flex-col gap-6">
    @if (hasDspAdvertisers()) {
      <app-compact-filter [filters]="adTypeFilters()" (filterChange)="applyFilter($event)" />
    }
    <app-metric-selector
      (selectedMetricsChange)="selectMetrics($event)"
      [localStorageKey]="localStorageKey"
      [availableMetrics]="CHARTS_METRICS"
      [data]="totalStats()"
      [previousPeriodData]="previousTotalStats()"
      [splitData]="splitStats()"
      [previousSplitData]="previousSplitStats()"
      [dataLoading]="loading()"
    />

    @if (displayGlobalChart()) {
      <app-chart-layout
        withDateAggregation
        closable
        [dataLoading]="loading()"
        (closeClicked)="displayGlobalChart.set(false)"
        (aggregationChange)="dateAggregation.set($event)"
      >
        <ng-container chart-actions>
          @if (displaySplitStatsMenu()) {
            <ISelectMenu [(value)]="statsDisplayMode">
              <ISelectTrigger>
                <ISelectValue>
                  <div *iSelectValue="let value">
                    <span class="text-gray-800">{{ t("split-stats-mode-selection." + value) }}</span>
                  </div>
                </ISelectValue>
              </ISelectTrigger>
              <ISelectContent>
                <ISelectOption [value]="StatDisplayMode.ALL">{{ t("split-stats-mode-selection.all") }}</ISelectOption>
                <ISelectOption [value]="StatDisplayMode.SPLIT">{{
                  t("split-stats-mode-selection.split")
                }}</ISelectOption>
                <ISelectOption [value]="StatDisplayMode.ONLY_MANAGED">{{
                  t("split-stats-mode-selection.only_managed")
                }}</ISelectOption>
                <ISelectOption [value]="StatDisplayMode.ONLY_UNMANAGED">{{
                  t("split-stats-mode-selection.only_unmanaged")
                }}</ISelectOption>
              </ISelectContent>
            </ISelectMenu>
          }
        </ng-container>
        <IChart [data]="stats()" [config]="chartConfig()" />
      </app-chart-layout>
    } @else {
      <div class="flex justify-end">
        <button iButton variant="secondary" (click)="displayGlobalChart.set(true)">
          <IIcon name="chartLine" />
          {{ t("agency-board.show_global_chart") }}
        </button>
      </div>
    }

    <div class="ag-theme-quartz">
      <div class="mb-2 flex justify-end gap-2">
        <button iButton variant="secondary" (click)="restoreColumns()">
          {{ t("common.restore_columns") }}
        </button>

        <button iButton variant="secondary" [iDropdownMenuTrigger]="exportMenu" placement="bottom-end">
          <IIcon name="upload" />
          {{ t("common.export") }}
        </button>
        <ng-template #exportMenu>
          <IDropdownMenu>
            <button iDropdownMenuItem (click)="exportGlobalDataCsv()">
              {{ t("agency-board.export_global_stats") }}
            </button>
            <button iDropdownMenuItem (click)="exportDailyDataCsv()">
              {{ t("agency-board.export_daily_stats") }}
            </button>
          </IDropdownMenu>
        </ng-template>
      </div>
      <ag-grid-angular
        class="h-[45rem] w-full"
        [rowData]="gridData()"
        [gridOptions]="gridOptions"
        [statusBar]="STATUS_BAR"
      />
    </div>
  </div>
</ng-container>
